import React, { Component } from 'react';

class Profile extends Component {
	render() {
		return (
			<div className="container">
				<h1>Perfil de usuario</h1>
			</div>
		);
	}
}

export default Profile;



// WEBPACK FOOTER //
// ./src/components/User/index.js